// const log = require('loglevel')
import _ from "lodash"
import i18n from '@/i18n'
import {debug} from 'loglevel'
const path = require('path')
import {toc_options} from "@/site_settings"

function safe_limit(v, min, max) {
  // debug(v, min, max)
  const [min_, max_] = (min > max) ? [max, min] : [min, max]
  v = v > max_ ? max_ : v
  v = v < min_ ? min_ : v
  return v
}

function pubtime_str(pubtime) {
  pubtime = Number(pubtime)
  if(pubtime < 0) {
    var bc = true
    pubtime = -1 * pubtime
  }
  else {
    bc = false
  }
  const pt = String(pubtime)
  const yr = Number(pt.slice(0, 4))
  const mn = Number(pt.slice(4, 6))
  if(bc) return mn ? i18n.t('pubtime_str_bc', {yr: yr, mn: mn}) : i18n.t('pubyear_str_bc', {yr: yr})
  else return mn ? i18n.t('pubtime_str', {yr: yr, mn: mn}) : i18n.t('pubyear_str', {yr: yr})
}

function mainset_name(mainset_id) {
  const mainset_ = toc_options.find((i)=>(i.id == mainset_id) || (i.id == `${mainset_id}_mainset`))
  const name_ = mainset_ ? mainset_.name : undefined
  return name_
}

function find_mainset(uniname) {
  function walk_(n, uniname) {
    if(n.id && n.id == uniname) {
      return n
    }
    if(n.children) {
      for(var i = 0; i < n.children.length; i++) {
        var rr = walk_(n.children[i], uniname)
        if(rr !== undefined) {
          // debug('n::', n)
          if(n.id && n.id.endsWith('_subset')) {
            rr = Object.assign({
              subset_id: n.id.slice(0, n.id.length - 7),
              subset_name: n.name
            }, rr)
          }
          else if(n.id && n.id.endsWith('_mainset')) {
            rr = Object.assign({
              mainset_id: n.id.slice(0, n.id.length - 8),
              mainset_name: n.name
            }, rr)
          }
          return rr
        }
      }
    }
  }
  const root = {
    children: toc_options,
  }
  const r = walk_(root, uniname)
  return r ? r : {}
}
// debug('find_mainset(bio)', find_mainset('bio'))
// debug('find_mainset(tia)', find_mainset('tia'))
// debug('find_mainset(nmc)', find_mainset('nmc'))
// debug('find_mainset(lsg)', find_mainset('lsg'))
debug('find_mainset', find_mainset('wai'), find_mainset('cwl'), find_mainset('tcm'))

function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

const reHasTag = /<\/?[a-z][\s\S]*>/i
function hasTag(s) {
  const rr = undefined ? (s == undefined) : reHasTag.test(s)
  // debug('rr', rr)
  return rr
}

function fix_image_src(uniname, src, opt={}) {
  const {small} = opt
  if(['pmb', 'pmr', 'pmm', 'pmq'].includes(uniname)) {
    return path.join('/images', 'npm', 'images', src)
  }
  else if(['dic', 'dit', 'dif'].includes(uniname)) {
      return small
      ? path.join('/images/art/dictionary_s', src)
      : path.join('/images/art/dictionary', src)
  }
  else {
    return small && (uniname !== 'diw')
      ? path.join('/images', uniname, 'images_s', src)
      : path.join('/images', uniname, 'images', src)
  }
}

function objectToQueryString (obj) {
	var qs = _.reduce(obj, function(result, value, key) {
			return (!_.isNull(value) && !_.isUndefined(value)) ? (result += key + '=' + value + '&') : result;
	}, '').slice(0, -1);
	return qs;
}

const en_map = {
  "intro": "intro_en",
  "journal_name": "journal_en_name",
  "status": "status_en",
  "interval": "interval_en",
  "publish": "publish_en",
  "city": "city_en",
  "period": "period_en",
  "name": "name_en",
  "desc": "desc_en",
  "desc_short": "desc_en",
}
const $en = (v) => {
  if(i18n.locale == 'en') {
    if(en_map[v] !== undefined) return en_map[v]
  }
  return v
}

export {
  $en,
  pubtime_str,
  find_mainset,
  numberWithCommas,
  hasTag,
  fix_image_src,
  mainset_name,
  objectToQueryString,
  safe_limit,
}
